import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';



const TabOne = () => {

    return (
        <div>
            <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <div className="row row--30 align-items-center">
                                <div className="col-lg-5">
                                    <img className="radius-small" src='./images/tab/IEEE.png' alt="Corporate React Template" />
                                </div>
                                <div className="col-lg-7 mt_md--40 mt_sm--40">
                                    <div className="rn-default-tab">
                                        <div className="tab-button-panel">
                                            <TabList className="tab-button">
                                                <Tab>
                                                    <div className="rn-tab-button">
                                                        <button>Identity</button>
                                                    </div>   
                                                </Tab>
                                                <Tab>
                                                    <div className="rn-tab-button">
                                                        <button>Awards</button>
                                                    </div>   
                                                </Tab>
                                                <Tab>
                                                    <div className="rn-tab-button">
                                                        <button>Jobs at IEEE</button>
                                                    </div>   
                                                </Tab>
                                                <Tab>
                                                    <div className="rn-tab-button">
                                                        <button>Public Policy</button>
                                                    </div>   
                                                </Tab>
                                            </TabList>
                                        </div>

                                        <div className="tab-content-panel">
                                        <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>IEEE members collaborate on world‐changing technologies, from computing and sustainable energy systems to aerospace, robotics, communication, healthcare, and more.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            
                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>For over a century, IEEE has sponsored various programs to honor achievements in education, industry, research, and service. These awards and recognitions each have a unique mission and criteria and offer the opportunity to praise distinguished colleagues, dedicated teachers, and corporate leaders who have made a lasting impact on humanity, technology, and the profession.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>

                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>Working for IEEE is a rewarding experience for professionals from a variety of disciplines. As part of a global team, staff members have the opportunity to collaborate with a diverse set of colleagues whose talent and commitment to integrity make them one of the organization’s most valuable assets. IEEE offers competitive employee benefits for its full-time, part-time, and temporary employees.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>

                                            <TabPanel>
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>IEEE and its organizational units engage in coordinated public policy activities at the national, regional, and international levels in order to advance the mission and vision of securing the benefits of technology for the advancement of society. The IEEE Global Public Policy website provides a window into these activities, as well as a repository of all public policy positions and statements adopted by IEEE or its organizational units in order to support the goal of engaging and informing IEEE members, the public, and policymakers around the world on technology-related aspects of public policy issues.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tabs>
                    </div>
                    
                </div>
        </div>
    )
}

export default TabOne
